class CartReservationTimer extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'vl_cart_reservation_expiry';
    this.durationMs = 10 * 60 * 1000; // 10 minutes
  }

  connectedCallback() {
    this.textEl = this.querySelector('[data-reservation-text]');
    this.start();
  }

  start() {
    let expiry = parseInt(sessionStorage.getItem(this.storageKey), 10);
    const now = Date.now();
    if (!expiry || isNaN(expiry) || expiry <= now) {
      expiry = now + this.durationMs;
      try {
        sessionStorage.setItem(this.storageKey, String(expiry));
      } catch (e) {
        /* sessionStorage indisponible : on continue sans persister */
      }
    }
    this.expiry = expiry;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  tick() {
    const remaining = this.expiry - Date.now();
    if (remaining <= 0) {
      const newExpiry = Date.now() + this.durationMs;
      try {
        sessionStorage.setItem(this.storageKey, String(newExpiry));
      } catch (e) {
        /* noop */
      }
      this.expiry = newExpiry;
      return;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');
    if (this.textEl) {
      this.textEl.textContent = `Panier réservé pendant ${minutes}:${seconds}`;
    }
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}
